import api from '../..'
const getAreasList = () => {
  return api.get(`administration/areas/list`).then(({ data }) => data)
}

export default getAreasList
